// Bumped on every meaningful release. Visible in "More" and on the Login
// footer so anyone can confirm WHICH build is actually installed on a device
// (the iOS/Android apps bundle the web code — a store/TestFlight build only
// updates after `yarn build && npx cap sync`).
export const BUILD_ID = "2026.10.15-F";
